import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false
})
export class LoaderComponent {
  @Input() message: string = 'Loading...';
  @Input() visible: boolean = false;

  constructor() { }
}